<template>
  <div class="border border-[#E5E5E5] rounded-2xl bg-white shadow-sm p-[1.5rem]">
    <h2 class="font-medium text-lg text-black mb-[1rem] pb-[.75rem] border-b border-[#F0F0F0]">
      Aktivitas & Log Status
    </h2>
    <div
      v-if="activities && activities.length > 0"
      class="space-y-[.25rem]"
    >
      <div
        v-for="(item, index) in activities"
        :key="item.id || index"
        class="flex items-start justify-between"
      >
        <div class="flex items-start gap-[.5rem]">
          <div class="flex flex-col items-center self-stretch">
            <div :class="index === 0 ? 'dot-icon' : 'dot-icon-gray'" />
            <div
              v-if="index !== activities.length - 1"
              class="w-px bg-[#E5E5E5] grow mt-[.25rem] min-h-[35px]"
            />
          </div>
          <div>
            <div class="font-semibold text-black text-sm">
              {{ item.title }}
            </div>
            <div
              v-if="item.actor"
              class="text-xs text-[#737373] mt-0.5"
            >
              Oleh: {{ item.actor.name || '' }} {{ formatActorType(item.actor.type) }}
            </div>
          </div>
        </div>
        <div class="text-right">
          <div class="text-xs text-[#737373] font-medium">
            {{ formatDate(item.occurred_at) }}
          </div>
          <div class="text-xs text-[#A3A3A3] mt-0.5">
            {{ formatTime(item.occurred_at) }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="text-center text-[#A3A3A3] text-sm py-4"
    >
      Belum ada aktivitas
    </div>
  </div>
</template>

<style scoped>
.dot-icon {
  width: .65rem;
  height: .65rem;
  background-color: #F95031;
  border-radius: 50%;
  border: 1.5px solid #FFFFFF;
  box-shadow: 0 0 0 1px #F95031;
}

.dot-icon-gray {
  width: .65rem;
  height: .65rem;
  background-color: #737373;
  border-radius: 50%;
}
</style>

<script>
import { DDMMYYYY, TIME } from '@/libs/filterDate'

export default {
  name: 'ActivityLogCard',
  props: {
    activities: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '-'
      return DDMMYYYY(dateStr)
    },
    formatTime(dateStr) {
      if (!dateStr) return '-'
      return `${TIME(dateStr)} WIB`
    },
    formatActorType(type) {
      if (!type) return ''
      if (type === 'TALENT_LEAD') return '(Talent Lead)'
      if (type === 'PARTNER') return '(Partner)'
      if (type === 'ADMIN') return '(Admin)'
      return `(${type})`
    },
  },
}
</script>
